import { merge } from "theme-ui";
import originalTheme from "@lekoarts/gatsby-theme-jodie/src/gatsby-plugin-theme-ui";

const theme = merge(originalTheme, {
  fonts: {
    body: `"Work Sans", -apple-system, BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"`,
  },
  breakpoints: ["40em", "52em", "64em", "80em"], // mobile, tablet, desktop, large desktop
});

/*
*
40em = 40 × 16px = 640px
52em = 52 × 16px = 832px
64em = 64 × 16px = 1024px
80em = 80 × 16px = 1280px
*/

export default theme;
